import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info, CheckCircle, AlertTriangle, XCircle, X } from 'lucide-react';
import { DialogClose } from "@radix-ui/react-dialog";

const DietaryInfoModal: React.FC = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-6 w-6 text-gray-400 hover:text-orange-500">
          <Info className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md p-0 border-0 rounded-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-pink-500 p-4 relative">
          <DialogClose asChild>
            <button className="absolute top-3 right-3 text-white/80 hover:text-white">
              <X className="h-5 w-5" />
            </button>
          </DialogClose>
          <DialogTitle className="text-lg font-bold text-white pr-8">
            Nutritional Profile Guide
          </DialogTitle>
          <p className="text-white/80 text-xs mt-1">How to read your recipe's nutrition data</p>
        </div>

        {/* Content - Compact & Scannable */}
        <div className="p-4 space-y-4 bg-white dark:bg-gray-900 text-sm">

          {/* Macro Bar */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Macro Bar</h3>
            <p className="text-gray-600 dark:text-gray-400 text-xs">
              Shows % of calories from Protein, Fat & Carbs at a glance.
            </p>
          </div>

          {/* Carb Quality */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Carb Quality</h3>
            <p className="text-gray-600 dark:text-gray-400 text-xs">
              Complex (slow energy) vs Simple (quick sugar) carbs ratio.
            </p>
          </div>

          {/* Compliance Legend - Compact horizontal */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Compliance Status</h3>
            <div className="grid grid-cols-3 gap-2">
              <div className="flex flex-col items-center p-2 rounded-lg bg-teal-50 dark:bg-teal-900/30">
                <CheckCircle className="h-4 w-4 text-teal-500 mb-1" />
                <span className="text-xs font-medium text-teal-700 dark:text-teal-300">Compliant</span>
              </div>
              <div className="flex flex-col items-center p-2 rounded-lg bg-amber-50 dark:bg-amber-900/30">
                <AlertTriangle className="h-4 w-4 text-amber-500 mb-1" />
                <span className="text-xs font-medium text-amber-700 dark:text-amber-300">Consider</span>
              </div>
              <div className="flex flex-col items-center p-2 rounded-lg bg-rose-50 dark:bg-rose-900/30">
                <XCircle className="h-4 w-4 text-rose-500 mb-1" />
                <span className="text-xs font-medium text-rose-700 dark:text-rose-300">Not Met</span>
              </div>
            </div>
          </div>

          {/* Quick note */}
          <p className="text-[0.65rem] text-gray-400 dark:text-gray-500 text-center pt-2 border-t border-gray-100 dark:border-gray-800">
            Tap any dietary chip in the profile for detailed explanations
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DietaryInfoModal;
